module.exports = __webpack_public_path__ + "static/media/pin-primary-viajes.0fb2b953.png";